export const AI_FEATURES_FAQ_LINK =
  'https://help.growtherapy.com/clients/en/articles/15170434-grow-therapy-ai-features-data-privacy-faqs';
